export default [
    {
      path: '/mail-log/list',
      name: 'mail-log-list',
      component: () => import('@/views/mail-log/MailLogList.vue'),
      meta: {
        resource: 'MailLog',
        action: 'read',
      },
    },
  ]
